import axios from "axios";

export class AxiosHttpClient {
  constructor(baseURL) {
    this.abortController = new AbortController();
    this.signal = this.abortController.signal;

    this.axiosInstance = axios.create({
      baseURL,
      headers: { Accept: "application/json" },
      signal: this.signal,
    });

    this.axiosInstance.interceptors.request.use((config) => {
      if (!config.headers) config.headers = {};

      const hasToken = localStorage.getItem("@accessToken");
      if (hasToken) config.headers["Authorization"] = `Bearer ${hasToken}`;

      return config;
    });

    this.axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          this.abortController.abort();
          localStorage.removeItem("@accessToken");
          location.reload();

          return Promise.reject(error.response.data);
        }

        return Promise.reject(error);
      }
    );
  }

  get(url, config) {
    const response = this.axiosInstance.get(url, config);
    return response.data;
  }

  post(url, data, config) {
    const response = this.axiosInstance.post(url, data, config);
    return response.data;
  }

  put(url, data, config) {
    const response = this.axiosInstance.put(url, data, config);
    return response.data;
  }

  delete(url, config) {
    const response = this.axiosInstance.delete(url, config);
    return response.data;
  }

  patch(url, data, config) {
    const response = this.axiosInstance.patch(url, data, config);
    return response.data;
  }
}
